export default {
  TOGGLE_MENU: '📲 Mudança estado do menu',
  TOGGLE_DIRECTION: '🌆 Mudança direção do slide',
  CHANGE_CURSOR_STATE: '🖱 Mudança do estado do cursor',
  GET_VIEWPORT_DIMENSIONS: '↕ Captura de dimensões do viewport',
  SET_CURRENT_PREVIEW: '↕ Atualização do index do preview visível',
  SET_DID_SEE_INTRO_ANIM: '✅ Ja viu animação de introdução',
  SET_DID_SHOW_SELECTOR_PRESENTER: '✅ Mostrou a dica sobre atalho',
  SET_DID_WATCH_INTRO_ANIM_IN_SECTION: '✅ Ja viu a animação de introdução nessa sessão',
  SET_TOGGLE_CONTACT_MODAL_OPEN: '💬 Mudança de estado do modal de contato',
  SET_DID_SEE_DRAG_TOOLTIP: '👆 Atalho de arrastar usado ou tooltip já foi exibida'
}
